<div class="container-fluid" style="padding:0">
    <div class="row">
        <div class="col-lg-2 col-12">
            <app-navbar></app-navbar>
        </div>
        <div class="col-lg-10 col-12">
            <div class="row">
                <div class="col-lg-9">
                    <br>
                    <h2>Nuevas Compras</h2>
                </div>
                <div class="col-lg-2">
                </div>
            </div>

            <div class="row">
                <div class="col-lg-3">
                    <span class="bod">Buscar por nombre:</span><br>
                    <input [(ngModel)]="filtro.alumno" type="text" class="form-control" placeholder="Nombre del cliente">
                </div>
                <div class="col-lg-3">
                    <span class="bod">Buscar por apellido:</span><br>
                    <input [(ngModel)]="filtro.apellidos" type="text" class="form-control" placeholder="Apellidos del cliente">
                </div>
                <div class="col-lg-3"><br>
                    <button class="btn btn-success" (click)="getClientesFiltroText()">Filtrar</button>
                </div>
            </div>
            <br>
            <table  class="table table-striped row-border hover" style="text-align: center;">
                <thead class="thead-dark">
                    <tr>
                        <td>ID</td>
                        <td>Nombre</td>
                        <td>Celular</td>
                        <td>Grupo</td>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let cliente of clientes">
                        <td>{{cliente.id}}</td>
                        <td>{{cliente.nombre}}</td>
                        <td>{{cliente.celular}}</td>
                        <td>{{cliente.grupo}}</td>
                        <td><button class="btn btn-success" (click)="nuevaCompra(cliente.id)">Nueva Compra</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>